import { DefaultKeysAttributes } from "@albatrosdeveloper/ave-models-package";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { environment } from "environments/environment.prod";
import { IcreateDefaultKeys } from "./interfaces/createDefaultKeys.interface";
import {
  buildQuery,
  Ops,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { IPaginationResult, IRequestResult } from "app/common/interfaces";
import { Observable } from "rxjs";

const apiUrl = environment.API_CONFIGURATION_URL;
const moduleName = "default-keys";

@Injectable({
  providedIn: "root",
})
export class DefaultKeysServices extends AbstractService<
  DefaultKeysAttributes,
  IcreateDefaultKeys,
  IcreateDefaultKeys
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  withCountDefaultKeys(): Observable<IRequestResult<DefaultKeysAttributes>> {
    const query = buildQuery<DefaultKeysAttributes>(
      where("_deleted", Ops.eq(false))
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<DefaultKeysAttributes>>(API_URL);
  }

  updateDefaultKeys(data: IcreateDefaultKeys, id: string) {
    const fields = {
      fields: data,
    };

    const API_URL: string = apiUrl + `api/${moduleName}/${id}`;
    return this.http.patch<IRequestResult<DefaultKeysAttributes>>(
      API_URL,
      fields
    );
  }
}
